import React from 'react';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import Image from '@src/components/Image';
import { Body1, Body2 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

type Props = {
  children: React.ReactNode;
  titleSuffixPlus?: string;
  titlePlus?: string;
  popUp?: Boolean;
};

const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${padding}px ${padding / 2}px;
`;

const HeadItem = styled.View`
  flex-direction: row;
  margin-top: 10;
  align-items: center;
`;

const Plus = styled(FontIcon).attrs(({ theme }) => ({
  name: 'plus',
  color: theme.colors.primary,
}))`
  position: absolute;
  top: -8;
  left: 0;
`;

export const ItemPlus = styled(Body1)`
  color: ${({ theme }) => theme.colors.primary};
`;

const Icon = styled(Image)`
  width: 10px;
  height: 22px;
  resize-mode: contain;
  margin-left: 10px;
`;
const Component: React.FC<Props> = ({
  children,
  titleSuffixPlus,
  titlePlus,
  popUp,
}) => {
  return (
    <Container>
      <HeadItem>
        <Body2> {children} </Body2>
        <ItemPlus>{titlePlus}</ItemPlus>
        <Plus />
        <Body2> {titleSuffixPlus}</Body2>
        {popUp && (
          <Icon source={require('@src/assets/images/arrow-left.png')} />
        )}
      </HeadItem>
    </Container>
  );
};

Component.displayName = 'HeadTourPlus';

export default React.memo(Component);
